import { Injectable } from '@angular/core';
import {
  AnalyticsConstantsEvents,
  AnalyticsCustomPathParams,
  AnalyticsDetailsParams,
  AnalyticsConstantsParams,
  AnalyticsConstantsDefaultParams,
} from '../../../../app/shared/enums/analyticsEnums';
import { GA4AnalyticsService } from './ga4-analytics.service';

@Injectable({
  providedIn: 'root',
})
// Classe para agrupar todos os tracks para posteriormente ser chamado na aplicação
export class TracksServiceWeb {
  constructor(private ga4: GA4AnalyticsService) {
    if (
      !sessionStorage.getItem('business') ||
      !sessionStorage.getItem('business_channel') ||
      !sessionStorage.getItem('environment')
    ) {
      this.ga4.defaultParameters({
        analytics: {
          parameters: {
            business: AnalyticsConstantsDefaultParams.business,
            business_channel: AnalyticsConstantsDefaultParams.business_channel,
            environment: AnalyticsConstantsDefaultParams.environment,
            //gets user id from local storage
          },
        },
      });
    }
  }
  // variavel do implementation team que será a mesma durante todo o fluxo
  public implementationTeam: string =
    AnalyticsConstantsParams.implementation_team;

  // Métodos track genericos
  public genericTracks = {};

  // Métodos track da tela giro-aval/simulação
  public tracks = {
    // Disparar evento ao carregar a tela
    newEvent: (
      event_name: string,
      custom_path: string,
      details: string,
      dynamic?: boolean
    ) => {
      this.ga4.trackEvent({
        analytics: {
          event_name: AnalyticsConstantsEvents[`event_name_${event_name}`],
          parameters: {
            custom_path:
              AnalyticsCustomPathParams[`custom_path_${custom_path}`],
            implementation_team: this.implementationTeam,
            detail: dynamic
              ? details.toLowerCase().replace(/_/g, '-')
              : AnalyticsDetailsParams[`detail_${details}`],
          },
        },
      });
    },

    // Disparar evento ao clicar
    // clickEvent: () => {
    //     this.ga4.trackEvent({
    //         analytics: {
    //           event_name: AnalyticsConstantsEvents.event_name_click,
    //           parameters: {
    //             custom_path:
    //               AnalyticsCustomPathParams.custom_path_reneg_simulacao_prazo,
    //             implementation_team: AnalyticsConstantsParams.implementation_team,
    //             detail: AnalyticsDetailsParams.detail_botao_beneficios_seguro,
    //           },
    //         },
    //       });
    // }
  };
}
